// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Diwo","newExpiryDate":"styles_newExpiryDate__2yQOR","footer":"styles_footer__21_1V"};